@use '@lib/assets/styles/main.scss' as *;

.root {
  border-radius: 50%;

  &:not(.dashed) {
    border: none;
    &.green {
      background: $success900;
    }

    &.blue {
      background: $blue500;
    }

    &.red {
      background: $error900;
    }

    &.orange {
      background: $orange;
    }

    &.white {
      background: $gray200;
    }

    &.lime {
      background: $lime;
    }

    &.gray {
      background: $gray400;
    }

    &.black {
      background: $gray700;
    }

    &.aquamarine {
      background: $aquamarine;
    }

    &.violet {
      background: $violet;
    }

    &.pink {
      background: $pink;
    }

    &.corral {
      background: $corral;
    }

    &.yellow {
      background: $yellow;
    }

    &.brown {
      background: $brown;
    }
  }

  &.dashed {
    border-width: 3px;
    border-style: dashed;
    &.green {
      background: $greenLight;
      border-color: $success900;
    }

    &.blue {
      background: $blueLight;
      border-color: $blue500;
    }

    &.red {
      background: $error100;
      border-color: $error900;
    }

    &.orange {
      background: $orangeLight;
      border-color: $orange;
    }

    &.white {
      background: $gray0;
      border-color: $gray200;
    }

    &.lime {
      background: $limeLight;
      border-color: $lime;
    }

    &.gray {
      background: $gray50;
      border-color: $gray400;
    }

    &.black {
      background: $gray50;
      border-color: $gray700;
    }

    &.aquamarine {
      background: $aquamarineLight;
      border-color: $aquamarine;
    }

    &.violet {
      background: $violetLight;
      border-color: $violet;
    }

    &.pink {
      background: $pinkLight;
      border-color: $pink;
    }

    &.corral {
      background: $corralLight;
      border-color: $corral;
    }

    &.yellow {
      background: $yellowLight;
      border-color: $yellow;
    }

    &.brown {
      background: $brownLight;
      border-color: $brown;
    }
  }
}
